import React from 'react';
import styled from 'styled-components';
import { resolve } from 'library/helpers/path-resolver';

export const StyledTimestampRow = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  font-size: 0.92em;
`;

const StyledTimestamp = styled.div`
  display: flex;
  align-items: start;
  white-space: initial;
`;

export const TimestampRow = ({ record, org_id, timestamp_type }) => {
  let status, timestamp, day, time;

  const org_timestamps = record.organizations_requests.find(
    (r) => r['id'] == org_id
  );

  timestamp = resolve(org_timestamps, `${timestamp_type}_timestamp`, null);

  if (timestamp) {
    const date = new Date(parseInt(timestamp));
    const dayOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    const hrMinOptions = { hour: 'numeric', minute: 'numeric' };
    day = date.toLocaleDateString('en-US', dayOptions);
    time = date.toLocaleTimeString('en-US', hrMinOptions);
  }
  return (
    <StyledTimestamp>
      {day && time ? <div>{day + ' at ' + time}</div> : <div>&nbsp;</div>}
    </StyledTimestamp>
  );
};

const Timestamp = ({ record, componentData }) => (
  <StyledTimestampRow>
    {record.organizations_requests.map((o) => (
      <TimestampRow
        key={`timestamp-row-${record.id}`}
        record={record}
        org_id={o.id}
        timestamp_type={componentData.timestamp_type}
      />
    ))}
  </StyledTimestampRow>
);

export default Timestamp;
